import { render, staticRenderFns } from "./Founder.vue?vue&type=template&id=fdfc2bca&scoped=true"
import script from "./Founder.vue?vue&type=script&lang=js"
export * from "./Founder.vue?vue&type=script&lang=js"
import style0 from "./Founder.vue?vue&type=style&index=0&id=fdfc2bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfc2bca",
  null
  
)

export default component.exports